import { CloudArrowDownIcon } from '@heroicons/react/24/outline';
import { ColumnDef } from '@tanstack/react-table';
import { isEmpty } from 'radash';

import { Icon } from '@/components/core/Icon';
import { StatusColumn } from '@/components/shared';
import { useDateFormatter } from '@/hooks/useDateFormatter';
import { useTranslation } from '@/hooks/useTranslation';
import { createAssetLink } from '@/services/utils';

import ItemHistoryGrid from './ItemHistoryGrid';

const ItemHistoryEvents = ({ data }:any) => {
    const { t } = useTranslation();
    const { formatDate } = useDateFormatter();

    const columns: ColumnDef<any>[] = [
        {
            accessorKey: 'date',
            header: t('HISTORY.MODIFIED_WHEN'),
            cell: (info) => {
                const value = info.getValue();
                return value !== '' && value != null
                    ? formatDate(value as number, 'historyDateTime')
                    : '';
            },
            sortingFn: (rowA:any, rowB:any, columnId) => {
                const valueA = rowA.getValue(columnId);
                const valueB = rowB.getValue(columnId);
                if (!valueA && !valueB) return 0;
                if (!valueA) return 1;
                if (!valueB) return -1;
                return new Date(valueA).getTime() - new Date(valueB).getTime();
            },
            enableResizing: true,
        },{
            accessorKey: 'user',
            header: t('HISTORY.MODIFIED_BY'),
            enableResizing: true,
        },{
            accessorKey: '',
            header: t('MESSAGING.RECIPIENT'),
            enableResizing: true,
        },{
            accessorKey: 'event',
            header: t('HISTORY.EVENT'),
            enableResizing: true,
        },{
            accessorKey: 'additionalText',
            header: t('HISTORY.ADDITIONAL_TEXT'),
            enableResizing: true,
        },{
            accessorKey: '',
            header: t('HISTORY.TEXT'),
            enableResizing: true,
        },{
            accessorKey: 'assetPath',
            header: t('HISTORY.LINK'),
            meta: {
                pinned: true
            },
            enableResizing: false,
            cell: ({ row }) => {
                const link: string = createAssetLink(row.original) || '';
                return <> {!isEmpty(link)&& <a target="_self" href={link} title={t('DOWNLOAD_LABEL')}>
                    <Icon icon={CloudArrowDownIcon} variant="default" size={'md'} />
                </a>} </>;
            },
        },{
            accessorKey: 'status',
            header: t('STATUS'),
            enableResizing: true,
            cell: ({ row }) => <StatusColumn status={row.getValue('status')} message={row.original.message} />,
        }
    ];

    return <ItemHistoryGrid data={data} columns={columns} gridKey="Items-history-events" />;
};

export default ItemHistoryEvents;
